import React from 'react';
import "./BlogPost.css";

import strike1 from '../../Assets/b64/strike1.jpg';
import strike2 from '../../Assets/b64/strike2.jpg';
import strike3 from '../../Assets/b64/strike3.jpg';
import strike4 from '../../Assets/b64/strike4.jpg';
import strike5 from '../../Assets/b64/strike5.jpg';
import strike6 from '../../Assets/b64/strike6.jpg';
import strike7 from '../../Assets/b64/strike7.jpg';
import strike8 from '../../Assets/b64/strike8.jpg';
import strike9 from '../../Assets/b64/strike9.jpg';
import strike10 from '../../Assets/b64/strike10.jpg';

function Blog64(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Strikes to almost-strikes</h1>
            <h6>February 08, 2026 at 12:00 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="3" aria-label="Slide 4"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="4" aria-label="Slide 5"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="5" aria-label="Slide 6"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="6" aria-label="Slide 7"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="7" aria-label="Slide 8"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="8" aria-label="Slide 9"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="9" aria-label="Slide 10"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={strike1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike3} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike4} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike5} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike6} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike7} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike8} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike9} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={strike10} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>From strikes to almost-strikes (and a few dramatic gutter balls 😅), everyone had the chance to showcase their skills at bowling while simply enjoying the moment. 
                Beyond the game, it was about boosting morale, and creating memories that carry into how we work together every day.</p>
            <p>Here’s to elevating teamwork — one strike at a time. 🎳🚀</p>
            <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
              #MYTSoftDevSolutions</a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood</a>
              <a href='https://www.facebook.com/hashtag/markyourtargets' target='_blank' className='blog-link'>
              #MarkYourTargets </a>
              <a href='https://www.facebook.com/hashtag/masteryourtime' target='_blank' className='blog-link'>
              #MasterYourTime</a>
              <a href='https://www.facebook.com/hashtag/masteryourtask' target='_blank' className='blog-link'>
              #MasterYourTask</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog64;